import type { ThemeWithoutTokens } from '../theme.types';

export const avatarTokens = (theme: ThemeWithoutTokens) =>
  ({
    avatarBlueBackground: theme.colors.primary.dark,
    avatarGreenBackground: theme.colors.success.dark,
    avatarGreyBackground: theme.palette.grey500,
    avatarOrangeBackground: theme.colors.warning.dark,
    avatarPurpleBackground: theme.palette.purple500,
    avatarRedBackground: theme.colors.danger.dark,
    avatarBlueTextColor: theme.colors.body.textLight,
    avatarGreenTextColor: theme.colors.body.textLight,
    avatarGreyTextColor: theme.colors.body.textLight,
    avatarOrangeTextColor: theme.colors.body.textLight,
    avatarPurpleTextColor: theme.colors.body.textLight,
    avatarRedTextColor: theme.colors.body.textLight,
    avatarSizeXs: theme.space.component.y.m,
    avatarSizeS: theme.space.component.y.xl,
    avatarSizeM: theme.space.component.y.xxl,
    avatarSizeL: theme.space.component.y.xxxl,
  }) as const;
